import { render, staticRenderFns } from "./PollResult.vue?vue&type=template&id=31cc2641"
import script from "./PollResult.vue?vue&type=script&lang=js"
export * from "./PollResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports